import styled, { css } from 'styled-components';

const alignItems = {
  center: 'center',
  bottom: 'flex-end',
  top: 'flex-start',
};

const justifyContent = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end',
  around: 'space-around',
  between: 'space-between',
  evenly: 'space-evenly',
};

interface OwnProps {
  align?: keyof typeof alignItems;
  justify?: keyof typeof justifyContent;
}

const Row = styled.div<OwnProps>`
  ${({ align }) =>
    align &&
    css`
      align-items: ${alignItems[align]};
    `};

  display: flex;
  margin: 0;
  overflow-x: hidden;

  ${({ justify }) =>
    justify &&
    css`
      justify-content: ${justifyContent[justify]};
    `};
`;

export default Row;
